import Grid2 from '@mui/material/Unstable_Grid2';
import { styled } from '@mui/material/styles';

const paddings = {
  paddingY: 3,
  paddingX: 4
};

export const HeaderWrapper = styled(Grid2)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  textAlign: 'left',
  padding: `${theme.spacing(paddings.paddingY)} ${theme.spacing(paddings.paddingX)}`,
  marginTop: theme.spacing(1)
}));

export const ContentWrapper = styled(Grid2)(({ theme }) => ({
  padding: `${theme.spacing(paddings.paddingY)} ${theme.spacing(paddings.paddingX)}`
}));

export const FooterWrapper = styled(Grid2)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  padding: `${theme.spacing(paddings.paddingY)} ${theme.spacing(paddings.paddingX)}`
}));
